<template lang="html">
  <form-step
    :complete='complete'
    :step='step'
    :icon='icon'
    :title='title'
    @submit='submit'>
    <v-layout row wrap v-for='stop in stops' :key='stop.id'>
      <v-flex xs6>
        <v-icon color='primary'>
          mdi-map-marker
        </v-icon>
        <span>
          {{ stop.location }}
        </span>
      </v-flex>
      <v-flex
        xs6
        v-if='stop.id != stops[stops.length - 1].id'>
        <v-icon>
          mdi-calendar
        </v-icon>
        <span>
          <DateTimePicker
            name='stop-date'
            v-model='dates[stops.findIndex( item => item.id === stop.id ) ]'
            :minDate='minDate[ stops.findIndex( item=> item.id === stop.id ) ]'/>
        </span>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-spacer></v-spacer>
        <v-btn
          color='primary'
          type='submit'
          :loading='loading'
          :disabled='disabled'>
          Continue
        </v-btn>
      </v-flex>
    </v-layout>
  </form-step>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import dateToPython from '@/utils/dateToPython'
import DateTimePicker from './DateTimePicker'
import FormStep from './FormStep'

export default {
  components: {
    'form-step': FormStep,
    DateTimePicker
  },
  props: {
    complete: {
      type: Boolean,
      default: false
    },
    step: {
      type: [ String, Number ],
      default: 4
    },
    stops: {
      type: Array,
      default:[]
    },
    trip: {
      type: Object,
      default: {}
    },
    route: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    loading: false,
    dates: [],
    icon: 'mdi-calendar',
    title: 'Trip Date Info'
  }),
  computed: {
    disabled () {
      return !!this.loading
    },
    minDate () {
      var legTimes = this.legTravelTimes()
      const today = new Date().toISOString()
      return this.stops.filter(
        (item, idx, arr) => idx != arr.length - 1
      ).map(
        (stop, idx) => idx === 0 ?
        new Date(today).toISOString() :
        new Date(this.dates[idx - 1] ?
          new Date(this.dates[idx - 1]).getTime() + (legTimes[idx - 1] * 1000) :
          today
        ).toISOString()
      )
    },
    payload: vm => vm.dates.map((date, idx) => ({
      id: vm.stops[idx].id,
      datetime: date
    }), vm),
    ...mapGetters('dates', ['byDate'])
  },
  methods: {
    submit () {
      if (this.dates.length != this.stops.length - 1) {
        return this.raiseError({ message: 'Must select a date for all applicable stops' })
      };
      this.loading = true
      return this.updateStops(this.payload).then(() => {
        this.$emit('continue')
        this.dates = []
        this.loading = false
      }).catch(e => {
        this.raiseError(e)
        this.loading = false
      })
    },
    async updateStops (payload) {
      for (var i = 0; i < payload.length; i++) {
        let stopData = payload[i]
        let datetime = stopData.datetime
        delete stopData.datetime
        await this.checkDate(datetime)
        stopData.date = this.byDate(new Date(datetime)).id
        stopData.time = `${new Date(datetime).getHours()}:${new Date(datetime).getMinutes()}`
        await this.updateStop(stopData)
      }
    },
    async checkDate(datetime) {
      if (!this.byDate(new Date(datetime))) {
        const datePayload = {
          dispatch: this.trip.dispatch,
          date: dateToPython(new Date(datetime))
        }
        return await this.createDate(datePayload)
      }
      return await new Promise(resolve => setTimeout(() => resolve(), 0))
    },
    legTravelTimes () {
      var route = this.route.response.route[0]
      var legs = route.leg
      var times = []
      legs.forEach(leg => times.push(leg.travelTime))
      return times
    },
    ...mapActions('plan', [ 'updateStop' ]),
    ...mapActions('dates', { createDate: 'create' }),
    ...mapActions('app', [ 'raiseError' ])
  }
}
</script>

<style lang="css" scoped>
</style>
